/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Detail_ManageInputs */

const en_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise manages the weightings and your portfolio rebalances automatically. You hold the tokenized stocks the whole time, and can withdraw whenever you want.`)
};

const de_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise verwaltet die Gewichtungen, und Ihr Portfolio wird automatisch neu gewichtet. Sie halten die tokenisierten Aktien die ganze Zeit über und können jederzeit abheben.`)
};

const pt_br2_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Bitwise gerencia os pesos e seu portfólio é rebalanceado automaticamente. Você mantém as ações tokenizadas o tempo todo e pode sacar quando quiser.`)
};

const tr_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ağırlıkları Bitwise yönetir ve portföyünüz otomatik olarak yeniden dengelenir. Tokenleştirilmiş hisseleri her zaman siz tutarsınız ve istediğiniz zaman çekim yapabilirsiniz.`)
};

const zh_cn2_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 负责管理权重，投资组合会自动再平衡。代币化股票始终由你持有，你可以随时提取。`)
};

const zh_hk2_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 負責管理權重，投資組合會自動重新平衡。代幣化股票始終由你持有，你可隨時提取。`)
};

const ko_kr2_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise가 비중을 관리하고 포트폴리오는 자동으로 리밸런싱됩니다. 토큰화된 주식은 항상 본인이 보유하며, 언제든지 출금할 수 있습니다.`)
};

const ru_ru2_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise управляет весами, а портфель ребалансируется автоматически. Токенизированные акции всё время остаются у вас, и вывести средства можно в любой момент.`)
};

const es_419_campaigns_mag7_spacex_detail_manage = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise gestiona las ponderaciones y tu portafolio se rebalancea automáticamente. Tú mantienes las acciones tokenizadas todo el tiempo y puedes retirar cuando quieras.`)
};

/**
* | output |
* | --- |
* | "Bitwise manages the weightings and your portfolio rebalances automatically. You hold the tokenized stocks the whole time, and can withdraw whenever you want." |
*
* @param {Campaigns_Mag7_Spacex_Detail_ManageInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_detail_manage = /** @type {((inputs?: Campaigns_Mag7_Spacex_Detail_ManageInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Detail_ManageInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_detail_manage(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_detail_manage(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_detail_manage(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_detail_manage(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_detail_manage(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_detail_manage(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_detail_manage(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_detail_manage(inputs)
	return es_419_campaigns_mag7_spacex_detail_manage(inputs)
});